// NoAccessBanner.tsx
import React from 'react';
import EDBox from '../../../../../../BaseComponents/EDBox/EDBox';
import EDIcon from '../../../../../../BaseComponents/Icon/EDIcon';
import EDTypography from '../../../../../../BaseComponents/Typography/EDTypography';
import { themeColors } from '../../../../../../BaseComponents/ThemeProvider/AvenyThemeColors';

export const NoAccessBanner: React.FC = () => {
  return (
    <EDBox
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        marginRight: 2,
      }}
    >
      <EDBox
        sx={{
          backgroundColor: themeColors.teal[100],
          borderRadius: '12px',
          border: `1px solid ${themeColors.tealFade[500.15]}`,
          padding: '12px 14px',
          display: 'flex',
          flexDirection: 'column',
          gap: 0.5,
        }}
      >
        <EDBox sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <EDBox
            sx={{
              color: themeColors.teal[700],
              flexShrink: 0,
              display: 'flex',
            }}
          >
            <EDIcon
              iconType="lock"
              size="medium"
              customSvgColor={themeColors.teal[700]}
            />
          </EDBox>
          <EDTypography
            variant="body2"
            bold
            sx={{ color: themeColors.teal[700] }}
          >
            Behörighet saknas
          </EDTypography>
        </EDBox>
        <EDTypography
          variant="body2"
          sx={{ pl: '28px', color: themeColors.teal[700] }}
        >
          Kontrollera resursbehörighet i rutin Användare.
        </EDTypography>
      </EDBox>
      <EDBox
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          opacity: 0.5,
        }}
      ></EDBox>
    </EDBox>
  );
};
